module.exports = __webpack_public_path__ + "img/createproposal.68a0831f.svg";